<script setup>
import {ref, watch} from 'vue';
import {modalStore} from "../stores/ModalStore";

// emits
defineEmits(["closeModal"])

watch(() => modalStore.isOpened, (value) => {
    if (value) {
        const options = {
            backdrop: false,
        };
        const myModalEl = document.getElementById('detailModal');
        const myModal = bootstrap.Modal.getOrCreateInstance(myModalEl, options);
        myModal.show();
        modalStore.setIsOpened(true);
    } else {
        const options = {
            backdrop: false,
        };
        const myModalEl = document.getElementById('detailModal');
        const myModal = bootstrap.Modal.getOrCreateInstance(myModalEl, options);
        history.back();
        myModal.hide();
        modalStore.setIsOpened(false);
    }
});

</script>
<template>
    <div
        class="modal fade"
        id="detailModal"
        aria-hidden="true"
        aria-labelledby="cartModalLabel"
        tabindex="-1"
        data-bs-backdrop="false"
    >
        <div class="modal-dialog modal-fullscreen">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="articleModalLabel">
                        <!-- EVENT-SETTING.COM -->
                    </h1>
                    <button
                        type="button"
                        class="btn-close"
                        @click="modalStore.setIsOpened(false)"
                        data-bs-dismiss="modal"
                        aria-label="Schliessen"
                    ></button>
                </div>
                <div class="modal-body">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>
